import { ValidationError } from 'yup';

export const buildCurrencyFormatter = (currency = 'GHS', options?: Partial<Intl.NumberFormatOptions>) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    ...options,
  });

export const ghsSign = (amount: string) => amount.replace('GHS', '₵');

type KeysEnum<T> = { [P in keyof Required<T>]: string[] };

export function mapYupObjectError<T = Record<string, unknown>>(vError: any): KeysEnum<T> {
  type ReturnType = KeysEnum<T>;
  const error = vError as ValidationError;

  const func = (obj: ReturnType, err: ValidationError): ReturnType => {
    if (err.path) {
      // eslint-disable-next-line no-param-reassign
      obj[err.path] = err.errors;
    }
    return obj;
  };

  const mapped: ReturnType = error.inner?.reduce(func, {} as ReturnType) ?? {};

  return mapped;
}

export const objectMap = <ReturnV = unknown, FromV = unknown>(
  obj: Record<string, FromV>,
  fn: (value: FromV, key: string, i: number) => ReturnV,
  objConfig?: Record<string, string>,
): Record<string, ReturnV> => {
  const newObject: Record<string, ReturnV> = {};
  Object.entries(obj).forEach(([key, value], i) => {
    const newKey = objConfig?.[key] || key;
    newObject[newKey] = fn(value, key, i);
  });
  return newObject;
};

export const getEKey = () => {
  const one = '92r8R9H28Y';
  const two = '8j2H24R4R3';
  let back = '';
  for (let i = 0; i < 10; i++) {
    back += one[i] + two[i];
  }

  return back;
};

const getAscPart = () => {
  let back = '';
  for (let i = 1; i < 11; i++) {
    if (i === 10) {
      back += '0';
      break;
    }
    back += i;
  }
  return back;
};

const getDescPart = () => {
  let back = '';
  for (let i = 9; i > 3; i--) {
    back += i;
  }
  return back;
};

export const getIV = () => {
  const one = getAscPart();
  const two = getDescPart();
  const back = one + two;

  return back.concat(back);
};
